import React from 'react';
import { BookOpen, FileSignature, Calendar, MessageSquare, CheckSquare } from 'lucide-react';
export function OfferSection() {
  const deliverables = [{
    icon: <BookOpen className="w-8 h-8 text-brand-gold" data-id="element-65" />,
    title: 'El Manual "La Jefa de su Crédito"',
    desc: 'La guía paso a paso del sistema de 90 días.'
  }, {
    icon: <FileSignature className="w-8 h-8 text-brand-gold" data-id="element-66" />,
    title: 'Plantillas MDE',
    desc: 'Mis 3 cartas de disputa "rompe-algoritmos" listas para llenar y enviar.'
  }, {
    icon: <Calendar className="w-8 h-8 text-brand-gold" data-id="element-67" />,
    title: 'El Calendario de la Jefa',
    desc: 'Qué hacer exactamente el día 1, el día 30 y el día 60.'
  }, {
    icon: <MessageSquare className="w-8 h-8 text-brand-gold" data-id="element-68" />,
    title: 'Guion de Negociación',
    desc: 'Qué decirle exactamente a los cobradores para que acepten borrar la deuda por menos dinero.'
  }, {
    icon: <CheckSquare className="w-8 h-8 text-brand-gold" data-id="element-69" />,
    title: 'Lista de Verificación de Errores Fantasma',
    desc: 'Cómo encontrar los fallos ocultos que te quitan hasta 50 puntos hoy mismo.'
  }];
  return <section className="bg-brand-cream py-16 md:py-24 px-4" data-id="element-70">
      <div className="max-w-5xl mx-auto" data-id="element-71">
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-center text-brand-navy mb-16" data-id="element-72">
          Lo que obtienes hoy:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-73">
          {deliverables.map((item, index) => <div key={index} className={`bg-white p-8 rounded-2xl shadow-md border-l-4 border-brand-gold flex items-start gap-6 ${index === deliverables.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-74">
              <div className="bg-brand-cream p-4 rounded-full flex-shrink-0" data-id="element-75">
                {item.icon}
              </div>
              <div data-id="element-76">
                <h3 className="font-heading text-2xl font-bold text-brand-navy mb-2" data-id="element-77">
                  {item.title}
                </h3>
                <p className="font-body text-gray-600 text-lg" data-id="element-78">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}